<script setup lang="ts">
import { BriefcaseIcon, ReceiptTaxIcon } from '@heroicons/vue/solid'
import { initLegalAccountForm } from '../../../../utilities/account/useAccountFormLegal'
import {
    isLegalProfileAttributeLocked,
    useLegalAccountDataState,
} from '../../../../utilities/account/useAccountDataLegal'
import BaseInputText from '../../../base/BaseInputText.vue'
import {
    isLegalProfileAttributeHidden,
    isRequiredLegalProfileAttributesForInvestment,
    isRequiredRequiredLegalProfileAttributes,
} from '../../../../validation'

const { legalProfile } = useLegalAccountDataState()

initLegalAccountForm('Company Data')
</script>

<template>
    <div class="grid grid-cols-1 gap-x-4 gap-y-8 px-4 py-5 sm:grid-cols-2 sm:px-6">
        <div class="sm:col-span-1">
            <BaseInputText
                v-model="legalProfile.company_name"
                :icon="BriefcaseIcon"
                :required="isRequiredRequiredLegalProfileAttributes('company_name')"
                :required-2="isRequiredLegalProfileAttributesForInvestment('company_name')"
                :disabled="isLegalProfileAttributeLocked('company_name')"
                name="legal_account.company_name"
                :label="$t('legal_account.company_name')" />
        </div>

        <div class="sm:col-span-1">
            <BaseInputText
                v-model="legalProfile.registration_number"
                :icon="ReceiptTaxIcon"
                :required="isRequiredRequiredLegalProfileAttributes('registration_number')"
                :required-2="isRequiredLegalProfileAttributesForInvestment('registration_number')"
                :disabled="isLegalProfileAttributeLocked('registration_number')"
                name="legal_account.registration_number"
                :label="$t('legal_account.registration_number')" />
        </div>

        <div v-if="!isLegalProfileAttributeHidden('description')" class="sm:col-span-1">
            <BaseInputText
                v-model="legalProfile.description"
                :icon="BriefcaseIcon"
                :required="isRequiredRequiredLegalProfileAttributes('description')"
                :required-2="isRequiredLegalProfileAttributesForInvestment('description')"
                name="legal_account.description"
                :label="$t('legal_account.description')" />
        </div>
        <div v-if="!isLegalProfileAttributeHidden('legal_form')" class="sm:col-span-1">
            <BaseInputText
                v-model="legalProfile.legal_form"
                :icon="BriefcaseIcon"
                :required="isRequiredRequiredLegalProfileAttributes('legal_form')"
                :required-2="isRequiredLegalProfileAttributesForInvestment('legal_form')"
                :disabled="isLegalProfileAttributeLocked('legal_form')"
                rules="min:2"
                name="legal_account.legal_form"
                :label="$t('legal_account.legal_form')" />
        </div>

        <div v-if="!isLegalProfileAttributeHidden('registration_authority')" class="sm:col-span-1">
            <BaseInputText
                v-model="legalProfile.registration_authority"
                :icon="BriefcaseIcon"
                :required="isRequiredRequiredLegalProfileAttributes('registration_authority')"
                :required-2="isRequiredLegalProfileAttributesForInvestment('registration_authority')"
                :disabled="isLegalProfileAttributeLocked('registration_authority')"
                name="legal_account.registration_authority"
                :label="$t('legal_account.registration_authority')" />
        </div>
    </div>
</template>
